export default __webpack_public_path__ + "static/media/valuation.a76aaf00.png";